import newAccount from './newAccount.js';

/**
 * BuyerShippingInfo
 *
 * @namespace BuyerShippingInfo
 */
newAccount.BuyerShippingInfo = newAccount.BuyerShippingInfo || {
    // ---------------------------------------------
    //
    //        Public Methods
    //
    // ---------------------------------------------

    // ---------------------------------------------
    //
    //        Constructor
    //
    // ---------------------------------------------

    /**
     * @memberof BuyerShippingInfo
     * @example
     * BuyerShippingInfo.init(shipTo)
     * @param {object} shipTo
     */
    init: function(shipTo) {
        if (shipTo) {
            let shipToItems = shipTo.split('|');

            if(shipToItems.length < 2) {
                shipToItems = shipTo.split(',');
            }

            this.id = this.getKeyValue('id:', shipToItems);
            this.name = this.getKeyValue('name:', shipToItems);
            this.homePhone = this.getKeyValue('homePhone:', shipToItems);
            this.mobilePhone = this.getKeyValue('mobilePhone:', shipToItems);
            this.mobilePhoneCntry = this.getKeyValue('mobilePhoneCntry:', shipToItems);
            this.address1 = this.getKeyValue('address1:', shipToItems);
            this.address2 = this.getKeyValue('address2:', shipToItems);
            this.country = this.getKeyValue('country:', shipToItems);
            this.city = this.getKeyValue('city:', shipToItems);
            this.state = this.getKeyValue('district:', shipToItems);
            this.region = this.getKeyValue('region:', shipToItems);
            this.postalCode = this.getKeyValue('postalCode:', shipToItems);
            this.instructions = this.getKeyValue('instructions:', shipToItems);
            this.email = this.getKeyValue('email:', shipToItems);
        }
    },

    /**
     * @memberof BuyerShippingInfo
     * @example
     * BuyerShippingInfo.toString()
     * @returns {string} shipToStr
     */
    toString: function(){
        let shipToStr = "";

        shipToStr = this.addFieldStr(shipToStr, 'id:', this.id);
        shipToStr = this.addFieldStr(shipToStr, 'name:', this.name);
        shipToStr = this.addFieldStr(shipToStr, 'homePhone:', this.homePhone);
        shipToStr = this.addFieldStr(shipToStr, 'mobilePhone:', this.mobilePhone);
        shipToStr = this.addFieldStr(shipToStr, 'mobilePhoneCntry:', this.mobilePhoneCntry);
        shipToStr = this.addFieldStr(shipToStr, 'address1:', this.address1);
        shipToStr = this.addFieldStr(shipToStr, 'address2:', this.address2);
        shipToStr = this.addFieldStr(shipToStr, 'country:', this.country);
        shipToStr = this.addFieldStr(shipToStr, 'city:', this.city);
        shipToStr = this.addFieldStr(shipToStr, 'district:', this.state);
        shipToStr = this.addFieldStr(shipToStr, 'region:', this.region);
        shipToStr = this.addFieldStr(shipToStr, 'postalCode:', this.postalCode);
        shipToStr = this.addFieldStr(shipToStr, 'instructions:', this.instructions);
        shipToStr = this.addFieldStr(shipToStr, 'email:', this.email);

        return shipToStr;
    },

    /**
     * @memberof BuyerShippingInfo
     * @example
     * var buyerShippingInfo = BuyerShippingInfo.toJSON()
     * @returns {object} buyerShippingInfo
     */
    toJSON: function(){
        let buyerShippingInfo = {};

        buyerShippingInfo.id = this.id;
        buyerShippingInfo.name = this.name;
        buyerShippingInfo.homePhone = this.homePhone;
        buyerShippingInfo.mobilePhone = this.mobilePhone;
        buyerShippingInfo.mobilePhoneCntry = this.mobilePhoneCntry;
        buyerShippingInfo.address1 = this.address1;
        buyerShippingInfo.address2 = this.address2;
        buyerShippingInfo.country = this.country;
        buyerShippingInfo.city = this.city;
        buyerShippingInfo.state = this.state;
        buyerShippingInfo.region = this.region;
        buyerShippingInfo.postalCode = this.postalCode;
        buyerShippingInfo.instructions = this.instructions;
        buyerShippingInfo.email = this.email;

        return buyerShippingInfo;
    },

    /**
     * @memberof BuyerShippingInfo
     * @example
     * BuyerShippingInfo.isEmpty()
     * @returns {boolean} isEmpty
     */
    isEmpty: function(){
        return this.isFieldEmpty(this.id) &&
            this.isFieldEmpty(this.name) &&
            this.isFieldEmpty(this.homePhone) &&
            this.isFieldEmpty(this.mobilePhone) &&
            this.isFieldEmpty(this.mobilePhoneCntry) &&
            this.isFieldEmpty(this.address1) &&
            this.isFieldEmpty(this.address2) &&
            this.isFieldEmpty(this.country) &&
            this.isFieldEmpty(this.city) &&
            this.isFieldEmpty(this.state) &&
            this.isFieldEmpty(this.region) &&
            this.isFieldEmpty(this.postalCode) &&
            this.isFieldEmpty(this.instructions) &&
            this.isFieldEmpty(this.email);
    },

    /**
     * @memberof BuyerShippingInfo
     * @example
     * var keyValue = BuyerShippingInfo.getKeyValue()
     * @returns {string} keyValue
     */
    getKeyValue: function(key, shipToItems){
        let keyValue = "";

        if (shipToItems.length > 0) {
            for (let i=0;i<shipToItems.length;i++){
                if (shipToItems[i].indexOf(key) > -1){
                    let lengthOfKey = key.length;

                    keyValue = shipToItems[i].substr(lengthOfKey);
                    break;
                }
            }
        }

        return keyValue;
    },

    /**
     * @memberof BuyerShippingInfo
     * @example
     * var keyValue = BuyerShippingInfo.addFieldStr(shipToStr, fieldLabel, fieldValue)
     * @returns {string} shipToStr
     */
    addFieldStr: function(shipToStr, fieldLabel, fieldValue){
        if (fieldValue !== undefined && fieldValue.length > 0){
            if (shipToStr.length > 0){
                shipToStr += ',';
            }
            shipToStr += fieldLabel + fieldValue;
        }
        return shipToStr;
    },

    /**
     * @memberof BuyerShippingInfo
     * @example
     * BuyerShippingInfo.isFieldEmpty(fieldValue)
     * @returns {boolean} isFieldEmpty
     */
    isFieldEmpty: function(fieldValue){
        return fieldValue === null || fieldValue === undefined || fieldValue.length === 0;
    }
};

export default newAccount.BuyerShippingInfo;
